import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import Classes from './Services.module.css';
import { SERVICES } from '../../../../../data/services';
import { SITE } from '../../../../../data/siteConfig';

export default function Services() {
    return (
        <section id="services" className="section">
            <div className="container">
                <div className="section-head center">
                    <div className="eyebrow">Our Services</div>
                    <h2 className="section-title">Full-Service Home Improvement</h2>
                    <p className="section-lead">
                        From major remodels to everyday repairs, one licensed team handles it all with dependable craftsmanship and service you can trust.
                    </p>
                </div>

                <div className={Classes.grid}>
                    {SERVICES.map((s, i) => (
                        <motion.div
                            key={s.slug}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.1 }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                        >
                            <Link to={`/services/${s.slug}`} className={Classes.card}>
                                <span className={Classes.icon}><img src={s.icon} alt="" aria-hidden="true" /></span>
                                <h3>{s.name}</h3>
                                <p>{s.summary}</p>
                                <span className={Classes.more}>Learn more <FaArrowRight /></span>
                            </Link>
                        </motion.div>
                    ))}
                </div>

                <div className={Classes.cta}>
                    <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-dark">Book an Appointment</a>
                </div>
            </div>
        </section>
    );
}
